import { useContext } from 'react';
import { ScrollContext } from './const';

export const useScrollContext = () => useContext(ScrollContext);